module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_rogaland_neg.d292ceb0.svg";